import {Anchor} from "../core/Anchor";
import {Button} from "./Button";

export class ShelfButton extends Button {
    public readonly hoverAnchor = Anchor.bottomCenter;
}
